export default "__VITE_ASSET__DJNOtGI4__"